export default __webpack_public_path__ + "static/ai-solutions-with-roadmap3-80aca27292b7f4d11294610528efd4b7.webp";